<template>
  <footer
    id="footer"
    class="page-footer"
  >
    <Spacer
      :bottom="{ default: 'l', m: 'xxl' }"
      :top="{ default: 'xs', m: 's' }"
      x="m"
    >
      <Wrapper size="xxl">
        <Spacer
          :y="{ default: 's', m: 'l' }"
          :bottom="{ default: 'm', m: 'l' }"
        >
          <div class="logo">
            <svg
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 416 129"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M36.72 73.095c-.55 0 3.025 5.507-2.475 5.231-1.925-.275-4.4-2.203-4.4-2.203s3.575-1.652 5.5-3.58c1.375-1.376 7.15-7.434 6.325-16.796-.825-10.463-7.975-9.637-9.075-9.086-9.625 3.029-11 14.043-11 14.043v1.377h-.275S2.896 56.297 2.621 67.037c-.275 4.68 6.6 10.188 14.3 11.29 4.95.55 9.9-.827 9.9-.827.274.276 4.949 4.681 8.799 4.406 6.6-1.102 1.65-9.087 1.1-8.811zm-20.35 1.927c-3.574-1.101-8.524-3.855-7.974-7.71.275-1.377 1.375-4.13 8.525-4.405 1.925 0 4.4.826 4.4.826 0 1.652.274 3.58.824 5.507.825 3.304 2.75 6.057 2.75 6.057s-3.575.826-8.524-.275zm9.075-13.768c.825-3.304 3.575-9.361 8.525-8.81 2.2.274 5.775 3.854 3.025 12.39-2.475 7.16-9.075 9.362-9.075 9.362s-4.4-4.956-2.475-12.942z"
                fill="#ffffff"
              />
              <path
                d="M57.069 72.82c.55 2.753 3.025 4.68 6.6 4.68 3.574 0 5.5-1.376 5.5-3.58 0-3.303-3.026-3.579-7.7-5.23-7.425-2.754-11.275-5.508-11.275-11.015 0-6.884 5.775-11.84 15.124-11.84 6.6 0 11.55 2.754 13.75 7.434l-7.7 3.855c-.825-2.753-3.025-4.13-6.05-4.13-3.3 0-5.224 1.377-5.224 3.58 0 3.029 3.3 3.855 8.524 5.507 7.425 2.478 11 5.507 11 11.29 0 6.883-5.775 11.84-15.4 11.84-7.7 0-13.199-3.03-14.849-7.71l7.7-4.681zM96.942 46.937h-10.45v36.346h10.45V46.937zM151.39 45.835c1.1 0 2.475.275 3.85.55l-1.65 11.29c-1.65-.55-3.3-1.101-4.95-1.101-6.599 0-9.074 3.304-9.074 10.738v15.97h-10.45V46.937h10.45l-.275 9.362c2.475-7.159 6.324-10.463 12.099-10.463zM160.464 46.937h10.724v36.346h-10.449V46.937h-.275zm5.224-20.927c3.3 0 6.325 2.753 6.325 6.058 0 3.58-2.75 6.333-6.325 6.333-3.299 0-6.049-3.03-6.049-6.334s2.75-6.057 6.049-6.057zM198.688 84.66c-11.275 0-19.25-7.986-19.25-19.55 0-11.565 7.975-19.275 19.525-19.275 3.574 0 6.599.55 9.624 2.203V58.5c-2.2-2.203-5.225-3.58-8.524-3.58-5.775 0-9.625 3.855-9.625 9.913s3.85 9.913 10.175 9.913c3.299 0 6.049-1.102 8.249-3.855v11.014c-3.3 1.927-6.6 2.754-10.174 2.754zM242.411 83.283l.275-5.232c-2.75 4.681-6.6 6.609-12.374 6.609-9.35 0-15.95-7.435-15.95-19.55 0-12.116 6.05-19.275 16.5-19.275 5.224 0 9.349 2.478 12.099 7.16v-6.059h9.9v36.347h-10.45zm-8.525-28.912c-5.774 0-9.349 4.13-9.349 10.463 0 6.609 3.3 10.464 9.074 10.464 5.775 0 9.075-3.855 9.075-10.464.275-6.608-3.3-10.463-8.8-10.463zM284.759 45.835c1.1 0 2.475.275 3.85.55l-1.65 11.29c-1.65-.55-3.3-1.101-4.949-1.101-6.6 0-9.075 3.304-9.075 10.738v15.97h-10.45V46.937h10.45l-.275 9.362c2.2-7.159 6.05-10.463 12.099-10.463zM293.833 46.937h10.45v36.346h-10.45V46.937zm4.95-20.927c3.3 0 6.325 2.753 6.325 6.058 0 3.58-2.75 6.333-6.325 6.333-3.3 0-6.05-3.03-6.05-6.334s2.75-6.057 6.05-6.057zM331.782 84.66c-11.274 0-19.249-7.986-19.249-19.55 0-11.565 7.975-19.275 19.524-19.275 3.575 0 6.6.55 9.625 2.203V58.5c-2.2-2.203-5.225-3.58-8.525-3.58-5.774 0-9.624 3.855-9.624 9.913s3.85 9.913 10.174 9.913c3.3 0 6.05-1.102 8.25-3.855v11.014c-3.3 1.927-6.325 2.754-10.175 2.754zM375.505 83.283l.275-5.232c-2.75 4.681-6.6 6.609-12.375 6.609-9.349 0-15.949-7.435-15.949-19.55 0-12.116 6.05-19.275 16.499-19.275 5.225 0 9.35 2.478 12.1 7.16v-6.059h9.899v36.347h-10.449zm-8.25-28.912c-5.775 0-9.349 4.13-9.349 10.463 0 6.609 3.299 10.464 9.074 10.464s9.075-3.855 9.075-10.464c.275-6.608-3.575-10.463-8.8-10.463z"
                fill="#ffffff"
              />
              <path
                d="M38.644 3.155H31.77v25.333h6.874V10.039h68.197v109.315H38.644V100.63H31.77v25.332h382.233V3.155H38.644zm143.269 6.884v18.449h6.875V10.039h68.197v18.449h6.874V10.039h68.197v18.449h6.875V10.039h68.197v109.315h-68.197V100.63h-6.875v18.724h-68.197V100.63h-6.874v18.724h-68.197V100.63h-6.875v18.724h-68.197V10.039h68.197z"
                fill="#ffffff"
              />
            </svg>
          </div>
        </Spacer>
        <Grid
          v-if="options && options.list"
          :col="{ default: 6, m: 3 }"
          class="page-footer__list"
        >
          <div>
            <Spacer :bottom="{ default: 'xs' , m: 'm' }">
              <Label :data="{ value: 'Sitemap', tag: 'h5', size: 'cta' }" />
            </Spacer>
            <div
              v-for="item in navigation"
              :key="item.id"
            >
              <a
                :href="item.url"
                @click="to"
              >
                {{ item.content }}
              </a>
            </div>
          </div>
          <div
            v-for="(item, index) in options.list"
            :key="index"
          >
            <Spacer :bottom="{ default: 'xs' , m: 'm' }">
              <Label :data="{ value: item.label, tag: 'h5', size: 'cta' }" />
            </Spacer>
            <div v-html="item.content" />
          </div>
        </Grid>
      </Wrapper>
    </Spacer>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

import goTo from '@/mixins/goTo';
import Label from '@/components/typo/label';

export default {
  name: 'Footer',
  components: {
    Label,
  },
  mixins: [goTo],
  computed: {
    options() {
      const { footer } = this.$store.state.wp.options;
      return footer;
    },

    ...mapGetters(['menu']),
    navigation() {
      const nav = this.menu('navigation');
      return nav ? nav.items : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer{
  background-color: $green;
  color: white;

  @include mq(m) {
    text-align: center;
  }

  @extend %typo--s;
}

.logo {
  width: 72px;
  transform: translate3d(-5px, 0, 0);

  @include mq(m) {
    transform: translate3d(-9px, 0, 0);
    width: 179px;
    margin: 0 auto;
  }
}
</style>
